import App from './App';

export default App;



// WEBPACK FOOTER //
// ./src/universal/components/App/index.js